//= require window.requestanimationframe/requestanimationframe.js

$(function() {
  'use strict';

  var $perspectives = $('.js-perspective[data-type="default"]'),
      $masks = $('.js-perspective[data-type="mask"]'),
      sensitivity = 100,
      initialOrientation = 0,
      lastEvent;

  $perspectives.each(function(index, container) {
    if(!Modernizr.touchevents) {
      var $container = $(container),
          $element = $container.find('.js-perspective-poster'),
          $shine = $container.find('.js-perspective-shine'),
          didMove = false;

      $container.on("mousemove", function(e) {
      	didMove = true;
        lastEvent = event;
      });

      (function loop() {
        requestAnimationFrame(loop);

        if(didMove) {
          var transform = perspective3D(lastEvent, $container, initialOrientation, 'mouse');

          applyRotation(transform, $element);

          didMove = false;
        }
      })();
    }
  });

  $masks.each(function(index, mask) {

    var $mask       = $(mask),
        $container  = $mask.find('.js-perspective-mask'),
        didMove = true,
        moveType;

    applyRotation({ rotateX: 0, rotateY: 0 }, $container);

    if(window.DeviceOrientationEvent && Modernizr.touchevents) {
      window.addEventListener("deviceorientation", function() {
        lastEvent = event;

        if(initialOrientation == 0) {
          initialOrientation = {
            alpha: Math.round(event.alpha * 1000) / 1000,
            beta: Math.round(event.beta * 1000) / 1000,
            gamma: Math.round(event.gamma * 1000) / 1000
          }
        }

        didMove = true;
        moveType = 'orientation'
      }, false);

    } else {
      $mask.on('mousemove', function(event) {
        lastEvent = event;
        didMove = true;
        moveType = 'mouse';
      });
     }

   (function loop() {
     requestAnimationFrame(loop);

     if(didMove) {
       var transform = perspective3D(lastEvent, $mask, initialOrientation, moveType);

       applyRotation(transform, $container);
     }
   })();
  });

  function perspective3D (event, $container, initialOrientation, moveType) {
    var w       = $container.innerWidth(),
        h       = $container.innerHeight(),
        ax,
        ay;

    if(moveType == 'mouse') {
      ay    = ( event.pageX - w / 2 - $container.offset().left ) / sensitivity,
      ax    = - ( event.pageY - h / 2 - $container.offset().top ) / sensitivity*1.5;
    }

    if(moveType == 'orientation') {
      var deltaBeta = (Math.round(event.beta * 1000) / 1000 - initialOrientation.beta),
          deltaAlpha = (Math.round(event.alpha * 1000) / 1000 - initialOrientation.alpha),
          deltaGamma = (Math.round(event.gamma * 1000) / 1000 - initialOrientation.gamma);

      if(deltaBeta >= 30) {
        initialOrientation.beta = initialOrientation.beta + deltaBeta - 30;
        deltaBeta = 30;
      } else if(deltaBeta <= -30) {
        initialOrientation.beta = initialOrientation.beta + deltaBeta + 30;
        deltaBeta = -30;
      }

      if(deltaAlpha >= 24) {
        initialOrientation.alpha = initialOrientation.alpha + deltaAlpha - 24;
        deltaAlpha = 24;
      } else if(deltaAlpha <= -24) {
        initialOrientation.alpha = initialOrientation.alpha + deltaAlpha + 24;
        deltaAlpha = -24;
      }

      if(deltaGamma >= 24) {
        initialOrientation.gamma = initialOrientation.gamma + deltaGamma - 24;
        deltaGamma = 24;
      } else if(deltaGamma <= -24) {
        initialOrientation.gamma = initialOrientation.gamma + deltaGamma + 24;
        deltaGamma = -24;
      }

      ax = deltaBeta;
      ay = ( ( event.beta / 90) * deltaAlpha ) + ( (1 - (event.beta - 90) / 90) * deltaGamma );

      ax = ax / 3;
      ay = ay / 5;
    }

    return { 'rotateX': ax, 'rotateY': ay };
  }

  function applyRotation (transform, $container) {
    $container.css({
      '-webkit-transform' : 'rotateY(' + transform.rotateY + 'deg) rotateX(' + transform.rotateX + 'deg)',
      'transform' : 'rotateY(' + transform.rotateY + 'deg) rotateX(' + transform.rotateX + 'deg)'
    });
  }

});
